console.log("shopflo_Ab");
function fireShopfloAnalyticsEvent(platform, merchantID) {
  let payload = {
    eventName: "checkout_clicked",
    sessionId: window.Shopflo.getSessionId(),
    timestamp: +new Date(),
    merchantId: merchantID,
    eventPayload: {
      uiData: {
        source: platform,
      },
      clientData: {
        clientIp: window.Shopflo.clientMeta.client_ip,
        userAgent: window.Shopflo.clientMeta.user_agent,
      },
    },
    eventType: "click",
    channel: "web",
  };

  if (navigator?.sendBeacon && Blob) {
    let blob = new Blob([JSON.stringify(payload)]);
    navigator.sendBeacon("https://hits.shopflo.com/api/v1/spark", blob);
  }
}

function getCookie(name) {
  let match = document.cookie.match(RegExp("(?:^|;\\s*)" + name + "=([^;]*)"));
  return match ? match[1] : null;
}
function isFloEnabled() {
  let num = Math.random();
  if (num < 0.25) return "shopflo";
  else return "gokwik";
}
if (getCookie("flo_checkout_enabled") == null) {
  let today = new Date();
  let expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 14);
  document.cookie =
    "flo_checkout_enabled=" +
    isFloEnabled() +
    ";path=/" +
    ";expires=" +
    expire.toGMTString();
}

function displaySelectedButton() {
  console.log("run for checkout");
  console.log(getCookie("flo_checkout_enabled"));
  if (getCookie("flo_checkout_enabled") === "shopflo") {
    document
      .querySelector(".shopflo-wrapper")
      .style.setProperty("display", "block", "important");
    document
      .querySelector(".gokwik-wrapper")
      .style.setProperty("display", "none", "important");
  } else {
    document
      .querySelector(".gokwik-wrapper")
      .style.setProperty("display", "block", "important");
    document
      .querySelector(".shopflo-wrapper")
      .style.setProperty("display", "none", "important");
  }
}

function displaySelectedButtonCart() {
  if (getCookie("flo_checkout_enabled") === "shopflo") {
    document
      .querySelector(".shopflo-wrapper-cart")
      .style.setProperty("display", "block", "important");
    document
      .querySelector(".gokwik-wrapper-cart")
      .style.setProperty("display", "none", "important");
  } else {
    document
      .querySelector(".gokwik-wrapper-cart")
      .style.setProperty("display", "block", "important");
    document
      .querySelector(".shopflo-wrapper-cart")
      .style.setProperty("display", "none", "important");
  }
}
function displaySelectedButtonBuyNow() {
  if (getCookie("flo_checkout_enabled") === "shopflo") {
    document
      .querySelector("#shopflo-wrapper-buy")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#gokwik-wrapper-buy")
      .style.setProperty("display", "none", "important");
    document
      .querySelector("#shopflo-wrapper-buy-mobile")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#gokwik-wrapper-buy-mobile")
      .style.setProperty("display", "none", "important");
  } else {
    document
      .querySelector("#gokwik-wrapper-buy")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#shopflo-wrapper-buy")
      .style.setProperty("display", "none", "important");
    document
      .querySelector("#gokwik-wrapper-buy-mobile")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#shopflo-wrapper-buy-mobile")
      .style.setProperty("display", "none", "important");
  }
}
